import Vue from 'vue';
import Vuex from 'vuex';

import { toolbar } from './toolbar.module';
import { auth } from './auth.module';
import { request } from './request.module';
import { bpm } from './bpm.module';
import { user } from './user.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        toolbar,
        auth,
        request,
        bpm,
        user
    }
});
